export default {
  '--app-primary-color': 'hsl(119, 36%, 30%)',
  '--app-secondary-color': 'hsl(0, 0%, 20%)',
  '--app-tertiary-color': 'hsl(133, 34%, 88%)',
  '--app-disabled-color': 'hsl(0, 0%, 89%)',
  '--sidebar-bg-color': 'hsl(0, 0%, 95%)',
  '--sidebar-icon-color': 'black',
  '--sidebar-text-color': 'hsl(0, 0%, 13%)',
  '--sidebar-active-bg-color': 'hsl(119, 36%, 30%)',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};